import React, { useRef } from "react";

import "./index.scss";

import { Link } from "react-router-dom";

import DynamicText from "../DynamicText";
// import Leaf from "../../images/leaf.png";

const Button = (props) => {
  const { color = "primary", type, url = "", onclickFunction, text = "button" } = props;

  const buttonColorAdmitted = useRef([
    "primary",
    "secondary",
    "accent",
    "danger",
    "warning",
    "success",
    "info",
    "white",
  ]);

  /**
   * color: [primary, secondary, accent, danger, warning, success, info]
   * type: [nat]
   */

  return (
    <React.Fragment>
      <Link
        // className={`button ${type === "" ? "button--primary" : `button--${type}`}`}
        className={`button button--${
          buttonColorAdmitted.current.includes(color)
            ? color
            : buttonColorAdmitted.current[0]
        } ${type ? `button-type--${type}` : ""}`}
        onClick={(e) => {
          if (onclickFunction && !url) {
            onclickFunction();
          }
        }}
        to={url && !onclickFunction ? url : null}>
        {/* {type === "nat" ? (
          <span>
            <img src={Leaf} className="button-leaf" alt={"foglia"} loading="lazy" />
          </span>
        ) : null} */}

        <DynamicText text={text} />
        <span className="button__glass"></span>
      </Link>
    </React.Fragment>
  );
};

export default Button;
